<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">
      
      <div class="sellprint-outer">
          <!-- 选择销售单信息 -->
          <div class="sellprint-show">
              <el-form :inline="true" class="demo-form-inline" size="small">
                  <el-form-item>
                      <el-input placeholder="请输入订单编号" v-model="pquery.key" clearable style="width:100%" @change="pquery.ischange=true"  @keyup.enter.native.prevent="getOrderlists" />
                  </el-form-item>
                  <el-form-item>
                      <el-button type="primary" size="small" icon="el-icon-search" round @click="getOrderlists">搜索</el-button>
                  </el-form-item>
              </el-form>

              <el-table :data="lists" v-loading="pquery.loading">
                  <el-table-column label="出库单号" align="left">
                      <template slot-scope="scope">
                          <div class="sellprint-documents">{{scope.row.documents}}<i>（{{scope.row.type}}）</i></div>
                          <div class="sellprint-documents-id">ID：{{scope.row.id}}</div>
                      </template>
                  </el-table-column>
                  <el-table-column label="出库单号" align="center" width="120">
                      <template slot-scope="scope">
                          <el-button size="mini" :type="scope.row.isselect==0 ? 'warning' : '' " round  @click="selectorcanelorder(scope.row)">{{scope.row.isselect==0 ? '选择出库单' : '取消出库单'}}</el-button>
                      </template>
                  </el-table-column>
	      	  </el-table>
              <div class="block">
                  <!--分页begin-->
                  <el-pagination
                      @size-change="orderPageSizeChange"
                      @current-change="orderPageCurrentChange"
                      :current-page="pquery.p"
                      :page-sizes="[10, 20, 50]"
                      :page-size="pquery.rollpage"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="pquery.rows">
                  </el-pagination>
                  <!--分页end-->
              </div>
          </div>

          <!-- 已选择的销售单信息 -->
          <div class="sellprint-select" v-loading="myselltemploading">
              <div class="sellprint-select-top">
                  <span class="sellprint-select-top-left">已选择出库单 <i>{{mysells.length}}</i> 个</span>
                  <el-button type="primary" size="mini" round icon="el-icon-printer" style="float:right" :disabled="mysells.length > 0 ? true : false" >打印面单</el-button>
                  <el-button type="danger" size="mini" round icon="el-icon-delete" style="float:right;margin-right:10px">删除全部出库单</el-button>
                  <el-button type="primary" size="mini" round icon="el-icon-refresh" style="float:right;">刷新选中出库单</el-button>
              </div>
              <div class="sellprint-select-bottom">
                  <el-table :data="mysells">
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <el-table :data="props.row.logistics">

                                    <el-table-column label="快递名称" align="left">
                                        <template slot-scope="propsinfo">
                                            <div style="width:100%;font-size:13px">{{propsinfo.row.logisticsname}}（{{propsinfo.row.code}}）</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="寄件人信息" align="left">
                                        <template slot-scope="propsinfo">
                                            <a class="sellprint-address-edit">
                                            <div style="width:100%;font-size:13px;line-height:21px">{{propsinfo.row.sendname}}，{{propsinfo.row.sendphone}}</div>
                                            <div style="width:100%;font-size:13px;line-height:21px">{{propsinfo.row.sendcity}}</div>
                                            <div style="width:100%;font-size:13px;line-height:21px">{{propsinfo.row.sendaddress}}</div>
                                            </a>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="收件人信息" align="left">
                                        <template slot-scope="propsinfo">
                                            <a class="sellprint-address-edit">
                                            <div style="width:100%;font-size:13px;line-height:21px">{{propsinfo.row.recievename}}，{{propsinfo.row.recievephone}}</div>
                                            <div style="width:100%;font-size:13px;line-height:21px">{{propsinfo.row.recievecity}}</div>
                                            <div style="width:100%;font-size:13px;line-height:21px">{{propsinfo.row.recieveaddress}}</div>
                                            </a>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" align="left" width="80">
                                        <template slot-scope="propsinfo">
                                            <el-button type="danger" circle size="mini" icon="el-icon-delete" />
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </el-table-column>

                        <el-table-column label="出库单号" align="left">
                            <template slot-scope="scope">
                                <div class="sellprint-documents">{{scope.row.documents}}<i>（{{scope.row.type}}）</i></div>
                                <div class="sellprint-documents-id">ID：{{scope.row.id}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="left" width="120">
                            <template slot-scope="propsinfo">
                                <el-button type="danger" circle size="mini" icon="el-icon-plus" />
                                <el-button type="danger" circle size="mini" icon="el-icon-delete" />
                            </template>
                        </el-table-column>
                        
	      	      </el-table>

              </div>
          </div>

      </div>

  </div>
  </transition>
</template>

<script>
export default {
  props:['childdata'],
  components: {},
  data () {
    return {
      url:this.GLOBAL.domain+"Sellshippingbirld/index",
      transitionshow:true,
      actionauth:[],
      pquery: {
          act:'getprintsells_news',
          token:this.$cookies.get('token'),
          key:'',
          loading:false,
          ischange:false,
          p:1,
          rollpage:10,
          rows:0
      },

      lists:[
          {id:1,documents:'XS20211100001',type:'线下订单',isselect:0},
          {id:2,documents:'XS20211100002',type:'线上商城',isselect:0},
          {id:3,documents:'XS20211100003',type:'跑店小程序',isselect:0},
          {id:4,documents:'XS20211100004',type:'线上商城',isselect:0},
          {id:5,documents:'XS20211100005',type:'线上商城',isselect:0},
          {id:6,documents:'XS20211100006',type:'线上商城',isselect:0},
          {id:7,documents:'XS20211100007',type:'线上商城',isselect:0},
          {id:8,documents:'XS20211100008',type:'线上商城',isselect:0},
          {id:9,documents:'XS20211100009',type:'线下订单',isselect:0},
          {id:10,documents:'XS20211100010',type:'线下订单',isselect:0},
      ],
      
      myselltemploading:false,
      templids:[],
      mysells:[
          {
             id:1,
             documents:'XS20211100001',
             type:'线下订单',
             logistics:[
                 {id:1,logisticsname:'中通速递',code:'T09678123456',sendname:'小王',sendphone:'13307717260',sendcity:'广西-南宁-江南区',sendaddress:'青秀区太平洋世纪广场',recievename:'黄大仙',recievephone:'15578990987',recievecity:'广东省-深圳市-龙岗区',recieveaddress:'莫某村'},
             ],
          },

          {
             id:2,
             documents:'XS20211100002',
             type:'线上商城',
             logistics:[
                 {id:2,logisticsname:'中通速递',code:'T09678123456',sendname:'小王',sendphone:'13307717260',sendcity:'广西-南宁-江南区',sendaddress:'青秀区太平洋世纪广场',recievename:'黄大仙',recievephone:'15578990987',recievecity:'广东省-深圳市-龙岗区',recieveaddress:'莫某村'},
                 {id:3,logisticsname:'中通速递',code:'T09678123456',sendname:'小王',sendphone:'13307717260',sendcity:'广西-南宁-江南区',sendaddress:'青秀区太平洋世纪广场',recievename:'黄大仙',recievephone:'15578990987',recievecity:'广东省-深圳市-龙岗区',recieveaddress:'莫某村'},
             ],
          }

      ],



    }  
  },

  
  
  mounted(){
      this.lists=[];
      this.mysells=[];
      this.getactionauth(); //获取权限设置
      this.getOrderlists();  //获取出库单信息
  },
  
  
  methods:{

    /** 选择/取消选择出库单 **/
    selectorcanelorder(item) {
        if(item.isselect==0) { //选择出库单

            //异步向服务器抓取销售单信息
            this.getprintorders(item.id);
            item.isselect=1;

        }else { //取消已选中的出库单

            var number='';
            number=this.templids.indexOf(item.id);
            if(number >=0) this.$delete(this.templids,number);
            this.mysells.forEach(function(e,index) {
                if(e.id==item.id) {number=index;return false;}
            });
            if(number >=0) this.$delete(this.mysells,number);
            item.isselect=0;

            this.freshgetsells(); //刷新已获取的出库单信息列表

        }
    },


    //获取选中的销售单信息
    getprintorders(id) {
        this.myselltemploading=true;
    	var resource = this.$resource(this.url);
        resource.save({act:'settingprintsell',token:this.$cookies.get('token'),id:id}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.myselltemploading=false;
            }else{
                
                //刷新已获取的出库单信息列表
                this.templids.push(id);
                this.freshgetsells(); 
            }
        }).catch((res) => {
            this.myselltemploading=false;
        });
    },


    //刷新已获取的出库单信息列表
    freshgetsells() {
        this.myselltemploading=true;
    	var resource = this.$resource(this.url);
        resource.save({act:'getprintlistsfromsellss',token:this.$cookies.get('token'),ids:this.templids.join(',')}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.myselltemploading=false;
            }else{
                this.mysells = JSON.parse(Base64.decode(res.data.Data));
                this.myselltemploading=false;
            }
        }).catch((res) => {
            this.myselltemploading=false;
        });
    },




    /** 获取出库单信息 **/
    getOrderlists() {
    	if(this.pquery.ischange==true) {
    		this.pquery.p=1;
    		this.pquery.rollpage=10;
    	}
    
    	this.pquery.loading=true;
    	var resource = this.$resource(this.url);
        resource.save(this.pquery).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.pquery.loading=false;
            }else{
                this.lists = JSON.parse(Base64.decode(res.data.Data));
                this.pquery.rows=parseInt(res.data.count);
                this.pquery.loading=false;
                if(this.pquery.ischange==true) this.pquery.ischange=false;

                var _this=this;
                this.lists.forEach(function(e,index) {
                    _this.templids.indexOf(e.id)==-1 ? e.isselect=0 : e.isselect=1;
                });

            }
        }).catch((res) => {
            this.pquery.loading=false;
        });
    },
    
    orderPageSizeChange(val) {
        this.pquery.rollpage = val;
        this.getOrderlists();
    },
    orderPageCurrentChange(val) {
        this.pquery.p = val;
        this.getOrderlists();
    },



    
    /** 获取操作功能权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },


    

    
  }
}
</script>

</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 3% 1%}
.sellprint-outer {height:600px;padding:1% 1% 0 1%;background:#fff;border-radius:15px;border:1px solid #ddd;overflow:hidden;}
.sellprint-show {float:left;width:30%;height:98%;padding:0 2% 0 0;border-right:1px solid #dddddd;overflow-x:auto;overflow-y:auto;}
.sellprint-show::-webkit-scrollbar {width:10px;height:10px;}
.sellprint-show::-webkit-scrollbar-thumb {border-radius: 15px;-webkit-box-shadow: inset 0 0 5px rgba(220,223,230,0.2);background: rgba(96,98,102,0.4);}
.sellprint-show::-webkit-scrollbar-track {-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);border-radius: 0;background: rgba(0,0,0,0.1);}


.sellprint-documents {font-size:13px;}
.sellprint-documents i {font-style:normal;font-size:12px}
.sellprint-documents-id {font-style:italic;font-size:12px;width:100%;display:inline-block;color:#999999}
.sellprint-select {float:left;width:calc(100% - 30% - 4% - 1px);height:98%;padding:0 0 0 2%;overflow:hidden;}
.sellprint-select-top {float:left;width:100%;padding:10px 0;border-bottom:1px solid #dddddd;}
.sellprint-select-top-left {float:left;font-size:13px;color:red}
.sellprint-select-top-left i {font-style:normal;font-size:15px;font-weight:550}

.sellprint-select-bottom {float:left;width:100%;height:calc(100% - 50px);overflow-x:hidden;overflow-y:scroll;}
.sellprint-select-bottom::-webkit-scrollbar {width:10px;height:10px;}
.sellprint-select-bottom::-webkit-scrollbar-thumb {border-radius: 15px;-webkit-box-shadow: inset 0 0 5px rgba(220,223,230,0.2);background: rgba(96,98,102,0.4);}
.sellprint-select-bottom::-webkit-scrollbar-track {-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);border-radius: 0;background: rgba(0,0,0,0.1);}

.sellprint-address-edit {border:1px dashed #999999;border-radius:6px;float:left;background:rgba(221,221,221,.3);padding:5px;cursor:pointer;}

</style>


// WEBPACK FOOTER //
// src/components/home/print/printer.vue